import React, { useState, useEffect } from "react";
import icon1 from "../../../assets/social-security-icons/compare-age.svg";
import timeIcon from "../../../assets/social-security-icons/ageCompare.svg";
import benefitIcon from "../../../assets/social-security-icons/benefit.svg";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import backIcon from "../../../assets/social-security-icons/backIcon.svg";
import { SocialSecurityFormFields } from "./SocialSecurityFormFields";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import "../styles/socialSecurity.css";
import { SocialSecurityHardCodeFields } from "./SocialSecurityHardCodeFields";
import { formatCurrencyAmount } from "../../../helpers/formatAmount";
import { calculateSocialSecurityResults } from "../../../helpers/socialSecurityCalculations";
import { MODULE_API } from "../../../apis";
import { compareRetirementAges } from "../../../helpers/retirementCompareCalculation";
import { SocialSecurityFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/SocialSecurityFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import CombinedSocialSecurityTable from "./CombinedSocialSecurityTable";

export const CompareTwoAges = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [results, setResults] = useState(null);
  const [userEntryResults, setUserEntryResults] = useState(null);
  const [socialFieldsData, setSocialFieldsData] = useState(null);
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [attributes, setAttributes] = useState(null);
  const module = "Social Security Compare Two Age";
  const moduleDataToFetch = "Social Security Calculator";

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const formFields = [
    {
      label: "First age years",
      type: "number",
      name: "firstYears",
    },
    {
      label: "First age months",
      type: "number",
      name: "firstMonths",
    },

    {
      label: "Second age years",
      type: "number",
      name: "secondYears",
    },
    {
      label: "Second age months",
      type: "number",
      name: "secondMonths",
    },
  ];
  const resultArray = [
    {
      id: 1,
      name: "First Age",
      icon: timeIcon,
      value:
        userEntryResults && userEntryResults.firstAge
          ? userEntryResults.firstAge
          : "N/A",
      subTitle1: "Months from FRA",
      value1:
        userEntryResults && userEntryResults.monthsFromFRA_first
          ? userEntryResults.monthsFromFRA_first
          : "N/A",
      subTitle2: "% FRA",
      value2:
        userEntryResults && userEntryResults["%FRA_first"]
          ? userEntryResults["%FRA_first"] + "%"
          : "N/A",
    },
    {
      id: 2,
      name: "Second Age",
      icon: timeIcon,
      value:
        userEntryResults && userEntryResults.secondAge
          ? userEntryResults.secondAge
          : "N/A",
      subTitle1: "Months from FRA",
      value1:
        userEntryResults && userEntryResults.monthsFromFRA_second
          ? userEntryResults.monthsFromFRA_second
          : "N/A",
      subTitle2: "% FRA",
      value2:
        userEntryResults && userEntryResults["%FRA_second"]
          ? userEntryResults["%FRA_second"] + "%"
          : "N/A",
    },
  ];
  const columns = [
    {
      title: "Early Monthly Benefit",
      dataIndex: "firstBenefit",
      key: "firstBenefit",
      render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
    },
    {
      title: "Later Monthly Benefit",
      dataIndex: "secondBenefit",
      key: "secondBenefit",
      render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
    },

    {
      title: (
        <div className="social-security-table-heading">
          Without TVM Interest or COLA
        </div>
      ),
      children: [
        {
          title: "Benefit from earlier start to later start age",
          dataIndex: "preFRA",
          key: "preFRA",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to break-even",
          dataIndex: "monthsToBreakEven_noTVM",
          key: "monthsToBreakEven_noTVM",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at break-even",
          dataIndex: "ageAtBreakEven_noTVM_formated",
          key: "ageAtBreakEven_noTVM_formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
    {
      title: (
        <div className="social-security-table-heading">With TVM and COLA</div>
      ),
      children: [
        {
          title: "Future value at 70 of pre-70 benefit",
          dataIndex: "futureValueAtLaterStart",
          key: "futureValueAtLaterStart",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to break-even with age 70",
          dataIndex: "monthsToBreakEven_TVM",
          key: "monthsToBreakEven_TVM",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at Break-even",
          dataIndex: "ageAtBreakEven_TVM_formated",
          key: "ageAtBreakEven_TVM_formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleDataToFetch,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setSocialFieldsData(res.records[0]);
        const socialData = res.records[0];
        const resultsAll = calculateSocialSecurityResults(res.records[0]);
        setResults(resultsAll);
        return socialData;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchModuleData = async (module, socialData) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setFormData(res.records[0]);
        const data = res.records[0];
        const FRA_YEARS = 67,
          FRA_MONTHS = 0;
        const First_YEARS = data["First Age Year"] || 0,
          First_MONTHS = data["First Age Month"] || 0;
        const Second_YEARS = data["Second Age Year"] || 0,
          Second_MONTHS = data["Second Age Month"] || 0;
        const FRA_BENEFIT =
          (socialFieldsData &&
            socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
          (socialData && socialData["Your Monthly Benefit at FRA ($)"]) ||
          0; // baseline at FRA
        const COLA = 0.02; // 2%
        const discountRate = 0.03;
        const lastResultData = compareRetirementAges(
          First_YEARS,
          First_MONTHS,
          Second_YEARS,
          Second_MONTHS,
          FRA_YEARS,
          FRA_MONTHS,
          FRA_BENEFIT,
          COLA,
          discountRate
        );
        setUserEntryResults(lastResultData);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Social Security fields
  const getFields = async (Name) => {
    setLoadingAttributes(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort((a, b) => a.priority - b.priority);
        setAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributes(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(module, {
        clientModules: [formData],
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAll = async () => {
    const socialData = await fetchData();
    await fetchModuleData(module, socialData);
  };
  useEffect(() => {
    getFields(module);
    fetchAll();
  }, []);

  const handleCalculate = () => {
    if (!formData) return;
    if (formData && formData.id) {
      updateRecord();
    } else {
      createAttributes();
    }
    if (formData && formData["First Age Year"] && formData["Second Age Year"]) {
      const FRA_YEARS = 67,
        FRA_MONTHS = 0;
      const First_YEARS = formData["First Age Year"] || 0,
        First_MONTHS = formData["First Age Month"] || 0;
      const Second_YEARS = formData["Second Age Year"] || 0,
        Second_MONTHS = formData["Second Age Month"] || 0;
      const FRA_BENEFIT =
        (socialFieldsData &&
          socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
        0; // baseline at FRA
      const COLA = 0.02; // 2%
      const discountRate = 0.03;
      const lastResultData = compareRetirementAges(
        First_YEARS,
        First_MONTHS,
        Second_YEARS,
        Second_MONTHS,
        FRA_YEARS,
        FRA_MONTHS,
        FRA_BENEFIT,
        COLA,
        discountRate
      );
      setUserEntryResults(lastResultData);
      console.log("last result", lastResultData);
    }
  };

  return (
    <div className="social-security-main">
      <div
        className="social-security-back-container"
        onClick={() => {
          history.push("/planner/social-security");
        }}
      >
        <div className="social-security-back-icon-container">
          <img width={16} height={16} src={backIcon} alt={"back Icon"}></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-back-text">Back to Social Security</div>
      </div>
      <div className="social-security-main-heading-container">
        <div className="social-security-icon-container">
          <img
            width={32}
            height={32}
            src={icon1}
            alt={"Retirement Calculator"}
          ></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-main-heading">
          Compare Break-even for any two ages
          <ToolTipCreator name={"retirement_earnings_tooltip"} />
        </div>
      </div>
      <div className="social-security-calculator-content-main">
        <div className="social-security-calculator-content-form-container">
          <div className="social-security-sub-title">
            Enter First Age and Second Age
          </div>
          {loadingAttributes ? (
            <SocialSecurityFormSkeleton rows={1} />
          ) : (
            <SocialSecurityFormFields
              formFields={attributes && attributes}
              formData={formData && formData}
              onChange={handleChange}
            />
          )}
          <button
            className="social-security-calculator-submit-button"
            onClick={(e) => {
              e.preventDefault();
              handleCalculate();
            }}
            disabled={loading || loadingAttributes || !formData}
          >
            Apply
          </button>
        </div>
        <div className="social-security-calculator-results">
          <h3>Results</h3>
          <div className="social-security-result-tag-container">
            {resultArray &&
              resultArray.map((item, index) => (
                <div
                  key={index}
                  className="social-security-main-heading-container"
                >
                  <div className="social-security-result-icon-container">
                    <img
                      width={32}
                      height={32}
                      src={item.icon}
                      alt={item.name}
                    ></img>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">{item.name} </div>
                    <div className="social-result-value">
                      {loading ? <NumberCardSkeleton /> : item.value}{" "}
                    </div>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">
                      {item.subTitle1}{" "}
                    </div>
                    <div className="social-result-value">
                      {loading ? <NumberCardSkeleton /> : item.value1}{" "}
                    </div>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">
                      {item.subTitle2}{" "}
                    </div>
                    <div className="social-result-value">
                      {loading ? <NumberCardSkeleton /> : item.value2}{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Breakdown of the results
          </div>
        </div>
        <div
          className="social-security-calculator-content-main"
          style={{ position: "relative" }}
        >
          <CombinedSocialSecurityTable
            tableData={userEntryResults ? [userEntryResults] : []}
            cols={columns}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </div>
  );
};
